class _nav {
    constructor() {
        this.toggleNav = $('#menu-toggle');
        this.navcontainer = $('.nav-container');
        this.body = $('body');
        let that = this;
        this.isOpen = false;
        $(this.toggleNav).on('click tap', function (e) {
            $(this).toggleClass("hamburger--squeeze js-hamburger is-active");
            if (that.isOpen) {
                that.closeNav();
            } else {
                that.openNav();
            }
        });
    }

    openNav() {
        const that = this;
        that.isOpen = true;
        that.body.addClass('nav-open');
        that.toggleNav.attr('aria-expanded', true);
        that.navcontainer.addClass('open');
    }

    closeNav() {
        const that = this;
        that.isOpen = false;
        that.body.removeClass('nav-open');
        that.toggleNav.attr('aria-expanded', false);
        that.navcontainer.removeClass('open');
    }
}
